import React from 'react';
import styled from 'styled-components';

import Typography from 'kingpin/atoms/Typography';

import { SHELL_PADDING } from './CardChrome';
import { VisTypeIcon } from './visTypes';

const Placeholder = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 0;
  padding: 0 ${SHELL_PADDING.x}px ${SHELL_PADDING.y}px;
  color: var(--color-icon-tertiary);

  svg {
    width: 44px;
    height: 44px;
  }
`;

// A block that can't draw yet: its vis type's icon and what it's missing
const ChartPlaceholder = ({
  cardId,
  visType,
  message,
}: {
  cardId: string;
  visType: Studio.VisType;
  message: string;
}) => (
  <Placeholder data-testid={`studio-card-missing-${cardId}`}>
    <VisTypeIcon visType={visType} />
    <Typography.Body
      type="Body 12"
      color="var(--color-text-tertiary)"
      textAlign="center"
    >
      {message}
    </Typography.Body>
  </Placeholder>
);

export default ChartPlaceholder;
